// extracted by mini-css-extract-plugin
export var info = "_0-0";
export var infoV2 = "_0-1";